import { DataSource } from '@angular/cdk/table';
import { Signaltag } from '../../models/trend-live-models/OPTag';
import { Observable, BehaviorSubject } from 'rxjs';

export class SignalTagsDs extends DataSource<Signaltag> {

    data = new BehaviorSubject<Signaltag[]>([]);

    connect(): Observable<Signaltag[]> {
        return this.data;
    }

    add(tag: Signaltag) {
        const data = this.data.getValue();
        data.push(tag);
        this.data.next(data);
    }

    change(tags: Signaltag[]) {
        this.data.next(tags);
    }

    remove(tag: Signaltag) {
        const data = this.data.getValue();
        this.data.next( data.filter(entry => entry !== tag));
    }

    disconnect() {

    }

    clear() {
        this.data.next([]);
    }
}



// WEBPACK FOOTER //
// ./src/components/trend-explorer/LegendDataSource.ts